import { leadSourceDefaultValue } from "client/services/hubspot-service/hubspot-constants";

export default {
  portalId: "5945317",
  formId: "215c1dc9-0c3c-44ad-be61-add5f71dfe22",
  source: leadSourceDefaultValue,
  withPrivacyNotice: true
};
